module.exports = __webpack_public_path__ + "img/Chat-link.66b20e0a.gif";